export interface Category {
    id?: number;
    name: string;
    validated_emails_count?: number;
}

export function CategoryFromJSON(json: any): Category {
    return {
        id: json["id"],
        name: json["name"],
        validated_emails_count: json["validated_emails_count"]
    }
}

export interface CompanyData {
    name: string;
    icp: string;
    linkedin: string;
    website: string;
    categories: Array<string>;
    emails: Array<string>;
}

export function CompanyDataFromJSON(json: any): CompanyData {
    return {
        name: json["name"],
        icp: json["icp"],
        linkedin: json["linkedin"],
        website: json["website"],
        categories: json["categories"],
        emails: json["emails"],
    }
}
